// Vyana theme front-end JS
// Keep this file lean — single IIFE, no framework, no build step.
(function () {
  // ----- Nav link injection (Press + Journal) -----
  // Belt-and-suspenders: even if sections/main-header.liquid hasn't synced
  // from GitHub yet, surface the nav items via JS so visitors can reach
  // /pages/press and /blogs/air-quality. No-op once the new section ships.
  (function injectNav () {
    var navList = document.querySelector('.site-nav ul');
    if (!navList) return;

    var existingHrefs = Array.prototype.slice
      .call(navList.querySelectorAll('a'))
      .map(function (a) { return a.getAttribute('href'); });

    var insertLink = function (href, label, isCurrentFn) {
      if (existingHrefs.indexOf(href) !== -1) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = href;
      a.textContent = label;
      if (isCurrentFn && isCurrentFn()) a.setAttribute('aria-current', 'page');
      li.appendChild(a);
      var contactLi = (function () {
        var c = navList.querySelector('a[href="/pages/contact"]');
        return c ? c.parentElement : null;
      })();
      if (contactLi) navList.insertBefore(li, contactLi);
      else navList.appendChild(li);
      existingHrefs.push(href);
    };

    insertLink('/pages/press', 'Press', function () {
      return location.pathname === '/pages/press';
    });
    insertLink('/blogs/air-quality', 'Journal', function () {
      return location.pathname.indexOf('/blogs') === 0;
    });
  })();


  // ----- Mobile menu drawer -----
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.querySelector('.site-nav');
  var body = document.body;

  if (toggle && nav) {
    var openMenu = function () {
      toggle.setAttribute('aria-expanded', 'true');
      nav.classList.add('is-open');
      body.classList.add('nav-open');
      // Move focus into the nav for keyboard users
      var firstLink = nav.querySelector('a');
      if (firstLink) firstLink.focus();
    };

    var closeMenu = function () {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      body.classList.remove('nav-open');
    };

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) closeMenu(); else openMenu();
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMenu();
        toggle.focus();
      }
    });

    // Close when a nav link is clicked (so the drawer doesn't stick around
    // on internal navigations to anchors on the same page)
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a) closeMenu();
    });

    // Close when the user clicks the dimmed page outside the drawer
    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;
      closeMenu();
    });
  }

  // ----- Header CTA scroll behaviour -----
  // (Reserved for future use — keep IIFE structure stable.)
})();
